import React from 'react';
import { getBillingScenarios } from '../utils/billingUtils';

export default function BillingScenarios({ 
  currentPlan, 
  requestedSeats, 
  onSelectScenario, 
  onCancel 
}) {
  const scenarios = getBillingScenarios(currentPlan, requestedSeats);
  
  // Auto-select the single scenario since there's only one option
  const selectedScenario = scenarios[0];
  
  const handleConfirm = () => {
    if (selectedScenario) {
      onSelectScenario(selectedScenario);
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Add Mentor to Your Plan</h3>
          <p className="text-gray-600 mb-6">
            You're adding {requestedSeats} mentor seat{requestedSeats > 1 ? 's' : ''} to your current plan.
          </p>
          
          {selectedScenario && (
            <div className="border-2 border-amber-500 bg-amber-50 rounded-xl p-6 mb-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="text-lg font-semibold text-amber-900 mb-2">
                    {selectedScenario.title}
                  </h4>
                  <p className="text-amber-800 mb-4">{selectedScenario.description}</p>
                  
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <span className="text-sm text-amber-700">Immediate Charge:</span>
                      <div className="font-semibold text-amber-900">
                        {selectedScenario.immediateCharge > 0 ? `$${selectedScenario.immediateCharge}` : 'No charge'}
                      </div>
                    </div>
                    <div>
                      <span className="text-sm text-amber-700">Next Billing Cycle:</span>
                      <div className="font-semibold text-amber-900">
                        ${selectedScenario.nextBillingCycle}/month
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-2">
                    {selectedScenario.benefits.map((benefit, benefitIndex) => (
                      <span
                        key={benefitIndex}
                        className="px-2 py-1 bg-amber-100 text-amber-800 text-xs rounded-full"
                      >
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
            >
              Add Mentor{requestedSeats > 1 ? 's' : ''}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
